<template>
    <div id="detail-layout">
        <viewer-container :activeData="activeData" :focus="focus" @pointedSelection="executeOnPointedSelection()"></viewer-container>
        <div id="tableWrapperContainer" style="position:absolute; bottom:0px; width:100%;">
            <!--<dynButton :configs="{ID: 'buttons.table-resize', visible: true}"
                btnClasses="table-resize-start" :icon="$root.icons.v_resize"
                :styleObj="{
                    'border-width':'2px',
                    //'border-top-right-radius': '35%', 
                    //'border-top-left-radius': '35%',
                    'border-style': 'solid', 'border-color':'#999',
                    'z-index':'999', 'position':'relative', 'top':'24px',
                    'width': '28px', 'height': '24px', 'padding': '1.7px',
                    'cursor': 'n-resize', 'background-color': '#666', 'color': 'white'}">
            </dynButton>-->
            <dynButton :configs="{ID: 'buttons.table-resize', visible: true}"
                btnClasses="table-resize-start" :icon="$root.icons.v_resize"
                :styleObj="{
                    'border-width':'2px',
                    //'border-top-right-radius': '35%', 
                    //'border-top-left-radius': '35%',
                    'border-style': 'solid', 'border-color':'#999',
                    'z-index':'999', 'position':'absolute', 'top':'0px',
                    'width': '28px', 'height': '24px', 'padding': '1.7px',
                    'cursor': 'n-resize', 'background-color': '#666', 'color': 'white'}">
            </dynButton>
            <!-- ATTEMPT HIDING SCROLLBAR-->
            <div id="dtw-container" class="table-resize-stop resizable_table" style="overflow-y: hidden; overflow-x: hidden;">
                <dyn-table-wrapper :arrayToTable="arrayToTable" :focus="focus" @API="assignAPI" @enabled="tableEnabled" name="WrapperGrid"></dyn-table-wrapper>
            </div> 
            
            <div id="resize-shadow" class="fake_resizable_table"
                style="z-index: -5; background-color: rgba(50, 62, 68, 0.13);  position: fixed;
                width: 100%; bottom: 0px;">
            </div>
        
        </div> 
        
    </div>
</template> 

<script>
import DynTableWrapper from "../dynamic/DynTableWrapper.vue";
import DynButton from "../dynamic/DynButton.vue";
import ViewerContainer from "./ViewerContainer.vue";

import table_resize_mixin from "../../mixins/table_resize_mixin.js";
import { eventBus } from "../../eventbus";
import deepExtend from "deep-extend";

export default {
  props: {
    activeData: Object,
    focus: String
  },
  components: {
    DynTableWrapper,
    DynButton,
    ViewerContainer
  },
  mounted: function() {
    if (this.activeData) {
      this.assignData();
    }
  },
  created: function(){
    var vm = this;
    eventBus.$on("heightMutation", function(){
      vm.initTableAndAdjust();
    })
  },
  mixins: [table_resize_mixin],
  data: function() {
    return {
      arrayToTable: [],
      dtwAPI: null
    };
  },
  watch: {
    activeData: function() {
      this.assignData();
    }
  },
  methods: {
    assignData: function() {
      var vm = this;

      //gestione delle righe con stesso codice e posizioni diverse
      for(var i=0; i<this.activeData.children.length; i++){
        if(this.activeData.children[i].pos == null){
          var zero_pos = Object.keys(this.activeData.children[i]).sort().find((e)=>e.includes('pos'))
          var first_pos = Object.keys(this.activeData.children[i]).sort().find((e)=>e.includes('pos') && !this.activeData.children.some((f)=>{
              var newe = e.replace("pos", '');
              return newe == f.pos && this.activeData.children[i][zero_pos].sid == f.sid;
            }) )
          if(first_pos != 'pos'){
            //faccio il merge delle prop nell'oggetto di primo livello con quelle dell'oggetto di secondo livello (facendo prevalere quelli del secondo)
            this.activeData.children[i] = deepExtend(this.activeData.children[i], this.activeData.children[i][first_pos])
          }
        }
      }

      this.arrayToTable = this.activeData.children.filter(function(obj){
        if(vm.$Behaviors.viewLinksInList){ //se voglio vedere i link nella lista
          return obj //mostro tutti, anche quelli con la proprietà link
        }else{
          return !obj.lin //mostro solo quelli che non hanno la proprietà link
        }
      });
      
      /* var ancestors = vm.$Configs.nodeInfo
      console.log(ancestors) */
      var ancestorsMapping = this.$root.front_end_configs.cartItemInfo
      console.log(ancestorsMapping)
      /* for(var anc in ancestors){
        if(vm.activeData.father.typ == anc){
          for(var a in ancestors[anc]){
            for(var p in ancestors[anc][a].properties){
              var name = ancestors[anc][a].properties[p].name
              var prop = ancestors[anc][a].properties[p].prop
            }
          }
        }
      } */
      try {
        this.arrayToTable = this.arrayToTable.map(function(obj){
          var r = obj,
            name, prop;
          if(obj.sor){
            //r.sor = Number(obj.sor);
            r.sor = obj.sor; //si può evitare il cast a Number solo se sor è sempre una stringa e se va bene ordinarlo come stringa 
          }

          console.log(vm.activeData.father)
          
          if(ancestorsMapping){
            r.f_fid = vm.activeData.father[ancestorsMapping.ldi] //codice linea
            r.f_sid = vm.activeData.father[ancestorsMapping.mpi] //codice macchina
            r.f_des = vm.activeData.father[ancestorsMapping.mde] //descrizione macchina
          }else{
            r.f_fid = ""
            r.f_sid = vm.activeData.father.sid //codice macchina
            r.f_des = vm.activeData.father.des //descrizione macchina
          }

          /* for(var anc in ancestors){
            var first = ancestors[anc]
            if(vm.activeData.father.typ == anc){
              for(var a in first){
                var second = first[a]
                for(var p in second.properties){
                  name = second.properties[p].name
                  prop = second.properties[p].prop
                  
                  if('any' in first){ //caso Unitec
                    if(a == 'any'){
                      if(prop == 'sid'){
                        r.f_sid = vm.activeData.father[name] //codice macchina 
                      }
                      if(prop == 'des'){
                        r.f_des = vm.activeData.father[name] //descrizione macchina 
                      }
                    }else if(prop == 'sid'){
                      r.f_fid = vm.activeData.father[name] //codice linea 
                    }
                  }else{
                    if(prop == 'sid'){
                      r.f_sid = vm.activeData.father[name] //codice macchina 
                    }
                    if(prop == 'des'){
                      r.f_des = vm.activeData.father[name] //descrizione macchina 
                    }
                  }
                }
              }
            }
          } */

          return r;
        })
        this.arrayToTable.sort(function(a, b){
          return a.sor - b.sor
        })
      } catch(err){
        console.log(err)
      }
      console.log(this.arrayToTable)
    },
    assignAPI: function(e){
      this.dtwAPI = e;
    },
    executeOnPointedSelection: function(){
      if(this.$Behaviors.hotspotLoadLinkedNode){
        try {
          var ref = this.$route.params.focus;
          if(ref != null){
            var ind = -1;
            this.activeData.children.some(function(child, index){
              if(child[this.$Behaviors.focusBy()] == ref){
                ind = index;
                return true;
              }
              return false;
            }, this)
            if(ind != -1){
              var target = this.activeData.children[ind];
              if(target.cco && target.cco > 0){
                this.$root.navigateTo(target.sid, target.fid)
              }
            } else {
              this.dtwAPI.scrollToSelection()
            }
          } else {
            this.dtwAPI.scrollToSelection()
          }
        } catch(err){
          this.dtwAPI.scrollToSelection()
        }
      } else {
        this.dtwAPI.scrollToSelection()
      }
    },
    tableEnabled: function(){
      this.adjust()
    }
  }
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/sub-views/Detail.vue?2eb596f4